import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isLoggedIn } from "../utils/authHelpers";

type UserProtectedRouteProps = {
  children: ReactNode;
  redirectPath?: string; // Optional custom redirect path
};

const UserProtectedRoute = ({
  children,
  redirectPath,
}: UserProtectedRouteProps) => {
  const authenticated = isLoggedIn();
  const location = useLocation();

  // If not authenticated, redirect to login with return URL or custom path
  if (!authenticated) {
    // Use custom redirect path if provided, otherwise default to login
    const redirect =
      redirectPath ||
      `/login?returnUrl=${encodeURIComponent(location.pathname)}`;
    return <Navigate to={redirect} replace />;
  }

  return <>{children}</>;
};

export default UserProtectedRoute;
